import debug from 'debug'
import { Color, extractRGB, Solver } from './color'

const d = debug('css')

export const buildStyleAttributes = (attr = {}) => {
  const extra = attr.color ? { WebkitTextFillColor: attr.color } : {}

  return { ...attr, ...extra }
}

/* Returns an invisible RGB if no hex is provided */
export const hexToRgb = (hex, alpha = 1) => {
  if (!hex) return `rgba(0,0,0,0)`

  const [r, g, b] = extractRGB(hex)

  return `rgba(${r},${g},${b},${alpha})`
}

export const buildForceColorFullString = color => `color:${color};fill:${color};-webkit-text-fill-color:${color};`

const hexToCssFilterCache = {}

export const hexToCssFilter = hex => {
  if (!hex) return ''

  const cleanHex = hex.toLowerCase()

  if (hexToCssFilterCache[cleanHex]) {
    if (d.enabled) {
      d('hexToCssFilter: found value in cache for', cleanHex)
    }
    return hexToCssFilterCache[cleanHex]
  }

  const t = d.enabled ? Date.now() : undefined

  const [r, g, b] = extractRGB(cleanHex)

  const color = new Color(r, g, b)
  const solver = new Solver(color)
  const result = solver.solve()
  const res = {
    color,
    solver,
    result
  }
  if (d.enabled) {
    d(
      'hexToCssFilter: found filter for %s - color to filter loss: %d (~1 is perfect, 5 is ok, 15 is bad) - generation time: %d ms',
      cleanHex,
      res.result.loss,
      Date.now() - t
    )
  }

  hexToCssFilterCache[cleanHex] = res.result.filter
  return res.result.filter
}
